import { render, staticRenderFns } from "./delivery-plan-desc.vue?vue&type=template&id=70a1cb1c&scoped=true&"
import script from "./delivery-plan-desc.vue?vue&type=script&lang=js&"
export * from "./delivery-plan-desc.vue?vue&type=script&lang=js&"
import style0 from "./delivery-plan-desc.vue?vue&type=style&index=0&id=70a1cb1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a1cb1c",
  null
  
)

export default component.exports